import { Contract } from "@/types/contract";
import { MobilePhoneFormatted } from "@/components/MobilePhoneFormatted";
import { getContactInfo } from "@/utils/customer";

interface CustomerMobilePhoneProps {
  contract: Contract;
}

export const CustomerMobilePhone = ({ contract }: CustomerMobilePhoneProps) => {
  const { mobilePhone, mobileCountryCode } = getContactInfo(contract);

  return <MobilePhoneFormatted mobilePhone={mobilePhone} mobileCountryCode={mobileCountryCode} />;
};
